import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RoleGroupRoleProjectIds } from 'projects/shared/src/lib/models/GroupRole';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { ProjectGroupRoleDto } from 'projects/shared/src/lib/models/projectgrouprole';
import { ProjectGroupRoleUser } from 'projects/shared/src/lib/models/SquirrelRoles';
import { GroupRolePermissionService } from 'projects/shared/src/lib/services/group-role-permission.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AddUserGroupRoleDialogComponent } from '../add-user-group-role-dialog/add-user-group-role-dialog.component';
import { GroupRoleClaimsDialogComponent } from '../group-role-claims-dialog/group-role-claims-dialog.component';
import { GroupRoleDeleteDialogComponent } from '../group-role-delete-dialog/group-role-delete-dialog.component';
import { UserGroupRolesDialogComponent } from '../user-group-roles-dialog/user-group-roles-dialog.component';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';

@Component({
  selector: 'project-roles-button-renderer',
  templateUrl: './project-roles-button-renderer.component.html',
  styleUrls: ['./project-roles-button-renderer.component.scss']
})
export class ProjectRolesButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  tenantdb!:string;
  numberOfUser!:number;

  icon_list!: string;
  icon_view!: string;
  icon_person!: string;
  icon_delete!: string;
  
  _db!:string;

  constructor(public dialog: MatDialog,
    private groupRolePermissionsService: GroupRolePermissionService,
    private tenantService:TenantService,
    public translate: TranslateService,
    private oauthService: OAuthServiceService,
    private notificationService: NotificationService) { 
    }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.icon_list = this.params.icon_list || null;
    this.icon_view = this.params.icon_view || null;
    this.icon_person = this.params.icon_person || null;
    this.icon_delete = this.params.icon_delete || null;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });

    this.refresh(params);
  }

  openGroupRoleClaimsDialog(){
    const rowData = [this.params.node.data]; 
    const roleId = rowData[0].id;
    const projectId = rowData[0].projectId;

    if(this._db){
      this.fetchFromMainDb(roleId, projectId);
    }
    else{
      this.fetchFromTenantDb(roleId, projectId);
    }   
  }

  fetchFromTenantDb(roleId:string, projectId:string) {
    // this.tenantService.checkForGroupRoleUsers(tenantdb, roleId, projectId).subscribe({
    //   next:(usersExist:any) => {
       // if(usersExist.item1 === true){
        let db:string = this.tenantService.currentTenantName;
        this.dialog.open(GroupRoleClaimsDialogComponent, { width: '500px', data: { roleId: roleId, projectId:projectId , db:db} });
        // }
        // else
        // {
        //   this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["NOPROJECTGROUPROLEUSERS"]} `);
        // }
    //   }
    // })
  }

  fetchFromMainDb(roleId:string, projectId:string) {
    // this.groupRolePermissionsService.checkForGroupRoleUsers(roleId, projectId).subscribe({
    //   next:(usersExist:any) => {
    //     if(usersExist.item1 === true){
              this.dialog.open(GroupRoleClaimsDialogComponent, { width: '500px', data: { roleId: roleId, projectId:projectId} });
    //     }
    //     else
    //     {
    //       this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["NOPROJECTGROUPROLEUSERS"]} `);
    //     }
    //   }
    // })
  }

  openViewUsersDialog(){
    const rowData = [this.params.node.data];

    // let roleGroupRoleProjectIds = new RoleGroupRoleProjectIds;
    // roleGroupRoleProjectIds.projectId = rowData[0].projectId;
    // roleGroupRoleProjectIds.roleId = rowData[0].id;

    console.log("-------> openViewUsersDialog: rowData = ", rowData)

    const dialogRef = this.dialog.open(UserGroupRolesDialogComponent, { width: '500px', data: {roleId: rowData[0].id,
                                                                                                roleName: rowData[0].name,
                                                                                                projectId:rowData[0].projectId } });
    dialogRef.afterClosed().subscribe({
      next: () => {
        //this.params.api.refreshInfiniteCache();
      },
    });
  }

  openUserGroupRoleDialog(){
   const rowData = [this.params.node.data];
   let projectGroupRoleUser = new ProjectGroupRoleUser;
   projectGroupRoleUser.roleId = rowData[0].id;
  //  projectGroupRoleUser.projectId = localStorage.getItem('project-id') as string;
   projectGroupRoleUser.projectId = this.tenantService.projectId;
   projectGroupRoleUser.roleName = rowData[0].name;
   const dialogRef = this.dialog.open(AddUserGroupRoleDialogComponent, { width: '500px', data: projectGroupRoleUser });
  }
  
  openGroupRoleDeleteDialog(){
    const rowData = [this.params.node.data];

    const roleId = rowData[0].id;
    const projectId = rowData[0].projectId;

    let projectGroupRole = new ProjectGroupRoleDto;
    projectGroupRole.id = rowData[0].id;
    projectGroupRole.name = rowData[0].name;
    projectGroupRole.projectId = rowData[0].projectId;

    // if(this._db){
    //   this.fetchDeleteFromMaindb(roleId, projectId, projectGroupRole);
    // }
    // else{
    //   this.fetchDeleteFromTenantdb(roleId, projectId, projectGroupRole);
    // }   

    this.fetchDeleteFromTenantdb(roleId, projectId, projectGroupRole);
  }

  fetchDeleteFromTenantdb(roleId: any, projectId: any, projectGroupRole: ProjectGroupRoleDto) {

    let db:string = this.tenantService.currentTenantName;
    this.tenantService.checkForGroupRoleUsers(db, roleId, projectId, new GenericFilter()).subscribe({
      next:(usersExist:any) => {
        console.log("project-roles-button-renderer usersExist=", usersExist);

        //this.numberOfUser = usersExist.item2;

//        if(usersExist.item1 === false){
        if(usersExist === false){
            const dialogRef = this.dialog.open(GroupRoleDeleteDialogComponent, { width: '500px', data: projectGroupRole });
          dialogRef.afterClosed().subscribe({
            next: () => {
              //this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEREMOVED"]} `);
              this.params.api.refreshInfiniteCache();
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEREMOVEDERROR"]}`)
          });
          //this.params.api.refreshInfiniteCache();
        }
        else
        {
          this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["THEREPROJECTGROUPROLEUSERS"]} `);
        }
      }
    });
  }

  fetchDeleteFromMaindb(roleId: any, projectId: any, projectGroupRole: ProjectGroupRoleDto) {
    this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEREMOVEDERROR"]}`)
    // this.groupRolePermissionsService.checkForGroupRoleUsers(roleId, projectId).subscribe({
    //   next:(usersExist:any) => {
    //     console.log(usersExist);

    //     this.numberOfUser = usersExist.item2;

    //     if(usersExist.item1 === false){
    //       const dialogRef = this.dialog.open(GroupRoleDeleteDialogComponent, { width: '500px', data: projectGroupRole });
    //       dialogRef.afterClosed().subscribe({
    //         next: () => {
    //           this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEREMOVED"]} `);
    //           this.params.api.refreshInfiniteCache();
    //         },
    //         error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTGROUPROLEREMOVEDERROR"]}`)
    //       });
    //    }
    //     else
    //     {
    //       this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["THEREPROJECTGROUPROLEUSERS"]} `);
    //     }
    //   }
    // })
  }
}
